import { FetchError } from '@/connection/helpers';
import { GetUserTemplateFavorites } from '@/connection/templates';
import { TemplatesReducerCreator } from '../types';

const fetchUserTemplateFavoritesReducer = (create: TemplatesReducerCreator) => {
  return create.asyncThunk(
    async ({ channel }: { channel: number }, { rejectWithValue }) => {
      try {
        const results = await GetUserTemplateFavorites({ channel });
        return results;
      } catch (error) {
        console.error(error);
        if (error instanceof FetchError) {
          return rejectWithValue(error.message);
        }

        throw error;
      }
    },
    {
      fulfilled: (state, action) => {
        if (action.payload) {
          state.userFavorites = action.payload;
        }
        state.loadingUserFavorites = false;
      },
      pending: (state) => {
        state.loadingUserFavorites = true;
      },
      rejected: (state) => {
        state.loadingUserFavorites = false;
      },
    }
  );
};

export default fetchUserTemplateFavoritesReducer;
